var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchiveTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.0332 3.18329H11.9665C8.4332 3.18329 5.5332 6.08329 5.5332 9.61662V33.1C5.5332 36.1 7.6832 37.3666 10.3165 35.9166L18.4499 31.4C19.3165 30.9166 20.7165 30.9166 21.5665 31.4L29.6999 35.9166C32.3332 37.3833 34.4832 36.1166 34.4832 33.1V9.61662C34.4665 6.08329 31.5832 3.18329 28.0332 3.18329Z",
    fill: "#FF4378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4831 22.0833C18.1665 22.0833 17.8498 21.9667 17.5998 21.7167L15.0998 19.2167C14.6165 18.7333 14.6165 17.9333 15.0998 17.45C15.5831 16.9667 16.3831 16.9667 16.8665 17.45L18.4831 19.0667L24.2665 13.2833C24.7498 12.8 25.5498 12.8 26.0331 13.2833C26.5165 13.7667 26.5165 14.5667 26.0331 15.05L19.3665 21.7167C19.1165 21.9667 18.7998 22.0833 18.4831 22.0833Z",
    fill: "#FF4378"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveTick);
export default __webpack_public_path__ + "static/media/archive-tick.77cd326eb73258053f6c1b88359b43e8.svg";
export { ForwardRef as ReactComponent };